import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import ProductIcon from '../../common/ProductIcon';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { SuiteFeaturesSubtext } from './SuiteFeaturesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuiteFeatures = ({
  productLevel,
  loading,
  isCollapsible = false
}) => {
  const DisplayedProductLines = AllCombinedProductLines;
  const HeaderSection = /*#__PURE__*/_jsx(FormattedMessage, {
    message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
  });
  const FeaturesListSection = /*#__PURE__*/_jsx(List, {
    children: DisplayedProductLines.map((localProductLine, index) => {
      return /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: index > 0 ? '300' : undefined,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          name: localProductLine,
          iconStyle: {
            blockSize: '32px',
            marginInlineEnd: '300'
          }
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typography: productLevel !== FREE ? 'body-125' : undefined,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteFeaturesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};